<template>
  <ipo3-page>
    <template slot="title">編輯視頻</template>
    <template slot="tools">
      <el-button type="primary" @click="goBack" icon="el-icon-back">返回新聞列表</el-button>
    </template>
    <template slot="page">
      <div id="video_edit">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="200px"
          class="demo-ruleForm"
        >
          <el-form-item label="視頻名稱" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>

          <!-- <el-form-item label="視頻簡介" prop="describe">
            <el-input v-model="ruleForm.describe" type="textarea" :rows="2"></el-input>
          </el-form-item> -->

          <el-form-item label="縮略圖" prop="thumb">
            <ipo3-upload @success="onSuccess" ref="upload"></ipo3-upload>
          </el-form-item>

          <el-form-item label="視頻地址" prop="path">
              <el-input v-model="ruleForm.path" ></el-input>
          </el-form-item>

          <el-form-item label="視頻時長" prop="duration">
              <el-input v-model="ruleForm.duration" type="number"></el-input>
          </el-form-item>
          <el-form-item label="是否嵌入">
            <el-switch v-model="ruleForm.isembed"></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </ipo3-page>
</template>
<script>
import { getToken } from "../../config/cache";
export default {
  name: "video-edit",
  data() {
    return {
      
      ruleForm: {
        type: "1",
        thumb: "",
        name: "",
        path: "",
        duration: 0,
        isembed:false,
      },
      edit: false,
      id: 0
    };
  },

  created() {
    if (this.$route.params.id !== undefined) {
      this.edit = true;
      this.id = this.$route.params.id;
      this.getData(this.$route.params.id);
    }
  },
  methods: {
    getData(id) {
      var self = this;
      this.$http.get("/admin/videos/detail", { id: id }).then(res => {
        console.log("res:", res);
        self.ruleForm = res.data;
        self.ruleForm.isembed = self.ruleForm.isembed==1?true:false;
        self.$refs.upload.setImage({
          url: self.ruleForm.thumb,
          name: "video.jpg"
        });
      });
    },
    onSuccess(value) {
      this.ruleForm.thumb = value.path;
    },
    onSubmit() {
      let params = Object.assign({}, this.ruleForm);
      params.isembed = params.isembed?1:0;
      this.$http.post("/admin/videos/edit", params).then(res => {
        console.log("res:", res);
        this.$message.success("編輯成功");
      });
    }
  }
};
</script>

<style lang="less">
#video_edit {
  width: 600px;
  text-align: left;
  .uploader-container {
    margin-top: 5px;
  }
}
</style>